import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaTruckMoving,
  FaTools,
  FaCogs,
  FaLock,
  FaSearch,
  FaStar,
  FaChartBar,
  FaClock
} from "react-icons/fa";

import styles from "./Menu.module.css";

const reportes = [
  {
    name: "Operaciones",
    icon: FaTruckMoving,
    path: "/informesope",
    enabled: true,
    desc: "Reportes generales área de operaciones",
    // badge: "Nuevo"
  },
  {
    name: "Registro y control",
    icon: FaTools,
    path: "/informes-registro",
    enabled: false,
    desc: "Trazabilidad documental y firmas"
  },
  {
    name: "Análisis",
    icon: FaCogs,
    path: "/informes-analisis",
    enabled: false,
    desc: "BI, tendencias y calidad"
  }
];

const Menuinformes = () => {
  const navigate = useNavigate();

  const [busqueda, setBusqueda] = useState("");
  const [favoritos, setFavoritos] = useState([]);

  const toggleFav = (name) => {
    setFavoritos((prev) =>
      prev.includes(name)
        ? prev.filter((f) => f !== name)
        : [...prev, name]
    );
  };

  const filtrados = reportes.filter((r) =>
    r.name.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div className={styles.container}>

      <h1 className={styles.title}>Reportes</h1>

      {/* BUSCADOR */}
      <div className={styles.searchBox}>
        <FaSearch />
        <input
          placeholder="Buscar reporte..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>

      <div className={styles.buttonGrid}>
        {filtrados.map((r) => {
          const Icon = r.enabled ? r.icon : FaLock;

          return (
            <div
              key={r.name}
              className={`${styles.card} ${
                !r.enabled ? styles.disabled : ""
              }`}
              onClick={() => r.enabled && navigate(r.path)}
            >
              {/* FAVORITOS */}
              <div
                className={styles.fav}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleFav(r.name);
                }}
              >
                <FaStar
                  className={
                    favoritos.includes(r.name)
                      ? styles.starOn
                      : styles.starOff
                  }
                />
              </div>

              {/* BADGE */}
              {r.badge && (
                <span className={styles.badge}>
                  {r.badge}
                </span>
              )}

              <Icon className={styles.icon} />

              <span className={styles.label}>{r.name}</span>

              <span className={styles.desc}>{r.desc}</span>

              <div className={styles.footer}>
                <FaChartBar /> <FaClock />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Menuinformes;
